//文字コードはutf-8
// ログアウト

export function logout() {
  $(function() {
    var data = {};
    $.ajax(
        "/veritas/old/screen_auth/check.php" + "?date=" + new Date().getTime(),
        {
            type : "post",
            data : data,
            dataType: 'json'
        }
    ).done(function(result){
        if("true" === result.result){
            $(".btn-logout").show();
        }
        else{
            $(".btn-logout").hide();
        }
        return false;
    });
  });


  $('.btn-logout').click(function() {
      var data = {};
      $.ajax(
          "/veritas/old/screen_auth/check.php" + "?date=" + new Date().getTime(),
          {
              type : "post",
              data : data,
              dataType: 'json'
          }
      ).done(function(result){
          if("true" === result.result){
              var confirm = window.confirm("ログアウトします。よろしいですか？");
              if(confirm){
                  data = {};
                  $.ajax(
                      "/veritas/old/screen_auth/logout.php" + "?date=" + new Date().getTime(),
                      {
                          type : "post",
                          data : data,
                          dataType: 'json'
                      }
                  ).done(function(result){
                      alert("ログアウトしました。");
                      $(".btn-logout").hide();
                      return false;
                  });
              }
          }
          else{
              alert("既にログアウト済です。");
              $(".btn-logout").hide();
          }
          return false;
      });
  });
}